/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tier_Feature_Support_EmailInputs */

const en_tier_feature_support_email = /** @type {(inputs: Tier_Feature_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email Support`)
};

const es_tier_feature_support_email = /** @type {(inputs: Tier_Feature_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte por correo electrónico`)
};

const fr_tier_feature_support_email = /** @type {(inputs: Tier_Feature_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support par E-mail`)
};

const de_tier_feature_support_email = /** @type {(inputs: Tier_Feature_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Support`)
};

const ja_tier_feature_support_email = /** @type {(inputs: Tier_Feature_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールサポート`)
};

const zh_tier_feature_support_email = /** @type {(inputs: Tier_Feature_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮件支持`)
};

const ar_tier_feature_support_email = /** @type {(inputs: Tier_Feature_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعم عبر البريد الإلكتروني`)
};

const id_tier_feature_support_email = /** @type {(inputs: Tier_Feature_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dukungan Email`)
};

const it_tier_feature_support_email = /** @type {(inputs: Tier_Feature_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supporto via E-mail`)
};

const ru_tier_feature_support_email = /** @type {(inputs: Tier_Feature_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддержка по Email`)
};

const pt_tier_feature_support_email = /** @type {(inputs: Tier_Feature_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suporte por E-mail`)
};

const ko_tier_feature_support_email = /** @type {(inputs: Tier_Feature_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 지원`)
};

/**
* | output |
* | --- |
* | "Email Support" |
*
* @param {Tier_Feature_Support_EmailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tier_feature_support_email = /** @type {((inputs?: Tier_Feature_Support_EmailInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tier_Feature_Support_EmailInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tier_feature_support_email(inputs)
	if (locale === "es") return es_tier_feature_support_email(inputs)
	if (locale === "fr") return fr_tier_feature_support_email(inputs)
	if (locale === "de") return de_tier_feature_support_email(inputs)
	if (locale === "ja") return ja_tier_feature_support_email(inputs)
	if (locale === "zh") return zh_tier_feature_support_email(inputs)
	if (locale === "ar") return ar_tier_feature_support_email(inputs)
	if (locale === "id") return id_tier_feature_support_email(inputs)
	if (locale === "it") return it_tier_feature_support_email(inputs)
	if (locale === "ru") return ru_tier_feature_support_email(inputs)
	if (locale === "pt") return pt_tier_feature_support_email(inputs)
	return ko_tier_feature_support_email(inputs)
});